import { Component, OnInit, ElementRef } from '@angular/core';
import { AlertService } from '../../Services/alert.service';
import { ViewChild } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ScrambleUnscrambleService } from 'src/app/Services/scramble-unscramble.service';
import { HttpServiceService } from 'src/app/Services/http-service.service';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { GlobalVariableService } from '../../Shared/global-variable.service';
import { MaterialModule } from 'src/app/Shared/Material/material.module';


@Component({
    selector: 'app-queries-requests',
    templateUrl: './queries-requests.component.html',
    styleUrls: ['./queries-requests.component.scss'],
    standalone: false
})

export class QueriesRequestsComponent implements OnInit {
  Cond = [
    { value: 'Request for SOA' },
    { value: 'Change in Bank Account' },
    { value: 'Change in Address' },
    { value: 'Change in Nominee' },
    { value: 'Request for TDS Certificates' },
    { value: 'Deal Related Query' },
    { value: 'Others' }
  ];
  servicerequesttext;
  querytext;
  complainttext;

  public servicerequestfilename: string = "No file chosen";
  public queryfilename: string = "No file chosen";
  public complaintfilename: string = "No file chosen";
  servicerequestimagedata: any;
  queryimagedata: any;
  complaintimagedata: any;

  mail_id:any;
  
  imagePath = ""; nisusadd :boolean = false;
  complainttab:boolean = false;
  servicetab : boolean = true;
  @ViewChild('servicerequestform') servicerequestformvalues;
  @ViewChild('queryform') queryform;
  @ViewChild('complaintform') complaintform;

  constructor(
    private router: Router,
    private _httpService: HttpServiceService,
    private detectorService: DeviceDetectorService,
    private spinnerService: NgxSpinnerService,
    private _scrambleUnscrambleService: ScrambleUnscrambleService,
    private alertService: AlertService,
    private _globalVariableService: GlobalVariableService) {
      this.imagePath = router.routerState.snapshot.url;
      let split = this.imagePath.split("/");
      let a = split[1];
      if (a == "dnisus") {
        this.complainttab = false;
        this.nisusadd = true;
        this.servicetab = true;
      }
      else {
        this.complainttab = true;
        this.nisusadd = false;
        this.servicetab = true;
  
      }  
  }


  ngOnInit() {
   }
  

  // ngAfterContentInit(){
  // }

  // getCategory() {
  //   let authid = sessionStorage.getItem("KrCGei");
  //   var sessionDetails = this._scrambleUnscrambleService.pefundApplyInternalFilter("Unveil", sessionStorage.getItem("ZhJtE" + authid), this._httpService.scrambleKey);
  //   sessionDetails = JSON.parse(sessionDetails);
  //   let flagDetails: any = {
  //     "flag": "GET_QUERIES",
  //     "tax_no": sessionDetails[0].pannumber,
  //     "email": sessionDetails[0].email,
  //     "session_id": sessionDetails[0].sessionid,
  //     "device_id": this.detectorService.getDeviceInfo().browser + " - " + this.detectorService.getDeviceInfo().browser_version,
  //     "os_id": this.detectorService.getDeviceInfo().os + " - " + this.detectorService.getDeviceInfo().os_version,
  //     "amc_code": "95"
  //   }

  //   this.spinnerService.show();
  //   this._httpService.getQueries(flagDetails).subscribe((data) => {
  //     data = JSON.parse(this._scrambleUnscrambleService.pefundApplyInternalFilter("Unveil", data, this._httpService.unscrambleKey));
  //     if (data.status.errorflag == true) {
  //       this.alertService.errorMsg(data.status.errormsg);
  //       if (data.status.errormsg.includes("Session Expired")) {
  //         let authid = sessionStorage.getItem("KrCGei");
  //         sessionStorage.removeItem("ZhJtE" + authid);
  //         sessionStorage.removeItem("KrCGei");
  //         this.router.navigate(['login']);
  //       }
  //       this.spinnerService.hide();
  //       return;
  //     } else {
  //       this.categoryresponse = [];
  //       this.categoryresponse = data.detail;
  //       this.catogories = [];
  //       this.catogories = _.uniqBy(data.detail, function (value) {
  //         return value.CATEGORY;
  //       });
  //       this.spinnerService.hide();
  //     }
  //   });
  // }

  // categorychanged() {
  //   this.Querys = [];
  //   this.Querys = _.filter(this.categoryresponse, (val) => {
  //     return val.CATEGORY == this.category._value;
  //   });
  // }

  emptyFile(formtype) {

    if (formtype == "servicerequest") {
      this.servicerequestfilename = "No file chosen";
      this.servicerequestimagedata = null;
    } else if (formtype == "query") {
      this.queryfilename = "No file chosen";
      this.queryimagedata = null;
    } else if (formtype == "complaint") {
      this.complaintfilename = "No file chosen";
      this.complaintimagedata = null;
    }

  }

  onFileChange(event, formtype) {
    var file = event.target.files[0];

    if (file == null || file == undefined) {
      this.emptyFile(formtype);
      return;
    }

    if (file.type == "application/pdf" || file.type == "image/png"
      || file.type == "image/jpg" || file.type == "image/jpeg") {
    } else {
      this.alertService.errorMsg('Invalid file type');
      this.emptyFile(formtype);
      return;
    }


    // if (file.size > 1000000) {
    //   this.alertService.errorMsg('File size should be less than 1MB');
    //   this.emptyFile(formtype);
    //   return;
    // }


    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e) => {
      if (file != undefined) {
        let base64: any = reader.result;
        base64 = base64.split(",");


        if (formtype == "servicerequest") {
          this.servicerequestimagedata = base64[1];
          this.servicerequestfilename = file.name;
        } else if (formtype == "query") {
          this.queryfilename = file.name;
          this.queryimagedata = base64[1];
        } else if (formtype == "complaint") {
          this.complaintfilename = file.name;
          this.complaintimagedata = base64[1];
        }



      } else {
        this.alertService.errorMsg('Select file');
        this.emptyFile(formtype);
        return;
      }
    }
  }

  // queryclicked() {
  //   if (!this.categorySelect) {
  //     this.alertService.errorMsg("Select Category Type")
  //     return;
  //   }
  // }

  onSubmit(value, type) {
    if (!(this._globalVariableService.folioNumber)) {
      this.alertService.errorMsg("Select Fund and Folio");
      return;
    }

    // if (isNullOrUndefined(value.category)) {
    //   this.alertService.errorMsg("Select Category type");
    //   return;
    // }

    // if (isNullOrUndefined(value.query)) {
    //   this.alertService.errorMsg("Select Query type");
    //   return;
    // }

    let textareavalue: any = "";
    let imageData: any = "";

    if (type == "servicerequest") {
      textareavalue = value.servicerequesttext ? value.servicerequesttext.trim() : "";
      imageData = this.servicerequestimagedata ? this.servicerequestimagedata : "";
    } else if (type == "query") {
      textareavalue = value.querytext ? value.querytext.trim() : "";
      imageData = this.queryimagedata ? this.queryimagedata : "";
    } else if (type == "complaint") {
      textareavalue = value.complainttext ? value.complainttext.trim() : "";
      imageData = this.complaintimagedata ? this.complaintimagedata : "";
    }

    if (!(textareavalue) && !(imageData)) {
      this.alertService.errorMsg("Please enter the query or upload file");
      return;
    }

    let authid = sessionStorage.getItem("KrCGei");
    var sessionDetails = this._scrambleUnscrambleService.pefundApplyInternalFilter("Unveil", sessionStorage.getItem("ZhJtE" + authid), this._httpService.scrambleKey);
    sessionDetails = JSON.parse(sessionDetails);

    let servicetype = (type == "complaint") ? "COMPLAINT" : "QUERY";

    let flagDetails: any = {
      "flag": "INS_QURIES_WORKFLOW",
      "tax_no": sessionDetails[0].pannumber,
      "email": sessionDetails[0].email,
      "image": imageData,
      "folio_no": this._globalVariableService.folioNumber,
      "servicetype": servicetype,
      "qaquery": textareavalue,
      "session_id": sessionDetails[0].sessionid,
      "device_id":this.detectorService.getDeviceInfo().browser,
      "os_id": this.detectorService.getDeviceInfo().os + " - " + this.detectorService.getDeviceInfo().os_version,
      "amc_code": this._globalVariableService.amc_code
    }

    this.spinnerService.show();
    this._httpService.uploadQuery(flagDetails).subscribe((data) => {
      data = JSON.parse(this._scrambleUnscrambleService.pefundApplyInternalFilter("Unveil", data, this._httpService.unscrambleKey));
      if (data.status.errorflag == true) {
        this.alertService.errorMsg(data.status.errormsg);
        if (data.status.errormsg.includes("Session Expired")) {
          let authid = sessionStorage.getItem("KrCGei");
          sessionStorage.removeItem("ZhJtE" + authid);
          sessionStorage.removeItem("KrCGei");
          this.router.navigate(['login']);
        }
        this.spinnerService.hide();
        return;
      } else {
        if (data.status.status == "SUCCESS") {

          this.alertService.successMsg(data.status.errormsg);

          if (type == "servicerequest") {
            this.servicerequestformvalues.resetForm();
          } else if (type == "query") {
            this.queryform.resetForm();
          } else if (type == "complaint") {
            this.complaintform.resetForm();
          }

          this.emptyFile(type);
        }
        this.spinnerService.hide();
      }
    });

  }

  


}
